// extracted by mini-css-extract-plugin
module.exports = {"expertDataProjects":"_1GcJy","title":"_3sqzX","projectsContainer":"bE_t5","projectItemContainer":"_2zy04","emptyProjectItemContainerFixingFlexWrapspaceBetweenLayout":"_1-TX5"};